import { types } from 'mobx-state-tree'

export const Loan = types.model('Loan', {
  displayId: '',
  title: '',
  settingsId: '',
  setupId: '',
})
